// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I_vrM{display:flex;flex-wrap:wrap;gap:8px;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `I_vrM`
};
export default ___CSS_LOADER_EXPORT___;
